import { ValidatorFn, FormGroup, ValidationErrors } from '@angular/forms';

export const passwordUpdate: ValidatorFn = (control: FormGroup): ValidationErrors | null => {
    const passwordNew = control.get('newPassword');
    const passwordConfirm = control.get('confirmNewPassword');
    return passwordNew && passwordConfirm && passwordNew.value === passwordConfirm.value ? null : {"errorPassword": true}
}